module.exports = __webpack_public_path__ + "static/media/together.82820f5c.jpg";